// Отправка заявки на бэкенд (Express → Telegram). Токен спрятан на сервере.
// Возвращает { ok: true } или { ok: false, error }.
export async function sendLead(data) {
  try {
    const res = await fetch("/api/lead", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok || !json.ok) {
      return {
        ok: false,
        error: (json.error || "Не удалось отправить заявку") + ". Отключите VPN, если он включён.",
      };
    }
    return { ok: true };
  } catch (e) {
    return {
      ok: false,
      error: "Не удалось отправить заявку. Отключите VPN, если он включён.",
    };
  }
}
